// Added by Sejune Oh on 2020-02-18
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC } from 'react';
import {
    FormControl as MaterialFormControl,
    FormControlProps as MaterialFormControlProps
} from '@material-ui/core'

interface FormControlBaseProps { }
export type FormControlProps = Partial<MaterialFormControlProps> & FormControlBaseProps

export const FormControl: FC<FormControlProps> = ({ ...props }) => {
    return <MaterialFormControl  {...props} />
}
